module.exports = __webpack_public_path__ + "static/media/icon-analytics-3.f4599923.svg";